import React from 'react';
import api from '../api';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import DownloadIcon from '@mui/icons-material/Download';

export default function WinnerAssetExportButton({ year, schoolId, categoryKey, label, size = 'small' }) {
    const [job, setJob] = React.useState(null);
    const [error, setError] = React.useState('');

    React.useEffect(() => {
        if (!job?.id || !['QUEUED', 'RUNNING'].includes(job.status)) return undefined;
        const timer = setTimeout(async () => {
            try {
                const response = await api.get(`/admin/api/winner-assets/exports/${job.id}`);
                setJob(response.data);
            } catch (requestError) {
                setError('Unable to check export progress.');
            }
        }, 1500);
        return () => clearTimeout(timer);
    }, [job]);

    const start = async () => {
        setError('');
        try {
            const body = categoryKey ? { categoryKey } : {};
            const response = await api.post(`/admin/api/winner-assets/${year}/schools/${schoolId}/exports`, body);
            setJob(response.data);
        } catch (requestError) {
            setError(requestError?.response?.data?.message || 'Unable to start export.');
        }
    };

    const download = async () => {
        try {
            const response = await api.get(`/admin/api/winner-assets/exports/${job.id}/download`);
            if (response.data?.url) window.open(response.data.url, '_blank', 'noopener,noreferrer');
        } catch (requestError) {
            setError('Unable to download this export.');
        }
    };

    if (job?.status === 'COMPLETED') {
        return <Button size={size} variant="contained" startIcon={<DownloadIcon />} onClick={download}>Download {job.outputFileName}</Button>;
    }
    if (job?.status === 'FAILED') {
        return <Box><Alert severity="error" sx={{ mb: 1 }}>{job.errorMessage || 'Export failed.'}</Alert><Button size={size} onClick={start}>Retry export</Button></Box>;
    }
    if (job && ['QUEUED', 'RUNNING'].includes(job.status)) {
        return <Button size={size} variant="outlined" disabled startIcon={<CircularProgress size={16} />}>Preparing ZIP</Button>;
    }
    return <Box><Button size={size} variant="outlined" startIcon={<DownloadIcon />} onClick={start}>{label}</Button>{error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}</Box>;
}